import Http from "../../http/client";

export default async (payload, userId) => {
  const response = await Http.patch('admin/users/'+userId, payload);
  return response.data;
}
